export default {
    title: '',
    city_id: null,
    order: 0,
}